import { toast } from 'react-toastify'

export const apiErrorMessage = error =>
    error?.error?.body?.['hydra:description'] || 'Whoops, there was a problem...'

export const showApiError = (error, actions) => {
    const violations = error?.error?.body?.violations || []

    if (actions) {
        violations.forEach(violation => actions.setFieldError(violation.propertyPath, violation.message))
        actions.setSubmitting(false)
    }

    console.error(error)
    toast.error(
        actions && violations.length > 0 ? 'Please check the highlighted fields.' : apiErrorMessage(error)
    )
}
